/* esm.sh - react-remove-scroll-bar@2.3.8 */
export * from "/*react-remove-scroll-bar@2.3.8/esnext/react-remove-scroll-bar.mjs";
